import React from 'react'
import classnames from 'classnames';

function Number(props) {
    const { label, options, onChange, className, faClass, required, ...rest } = props;
    return (
        <>
            {faClass && <i className={faClass}></i>}
            <label style={{ fontSize: '14px', fontWeight: '500' }}>{label}{required ?<i className="fas fa-asterisk ml-2" style={{ color: '#ff0000ba', fontSize: '8px' }} /> : null}</label>
            <input type='number'
                className={classnames(`form-control ${className}`)}
                onChange={onChange} {...rest} >
            </input>
        </>
    )
}

export default Number
